import { effects } from 'redux-saga'

import {
  makeSelectOfferFilterData,
  makeSelectProduct,
} from 'internal-components/src/redux/modules/product/selectors'

import { updateFilter } from '../../modules/signupEdit/actions'

export default function* watchUpdateFilter(action) {
  const state = yield effects.select()
  const filter = state.signupEdit.getIn(['meta', 'filter'])

  const offerDataSelector = yield effects.call(makeSelectOfferFilterData)
  const filterData = yield effects.call(offerDataSelector, state, {
    filter,
    addressSupplied: !!state.signupEdit.getIn(['edit', 'address']),
  })

  const selector = yield effects.call(makeSelectProduct)
  let product
  if (action.payload.field !== 'productId') {
    product = yield effects.call(selector, state, {
      productId: filter.productId,
    })
  }

  switch (action.payload.field) {
    case 'productId': {
      product = yield effects.call(selector, state, {
        productId: action.payload.value,
      })

      if (!product) {
        return
      }

      yield effects.put.resolve(
        updateFilter(
          'speed',
          product.type === 'HOSTING' ? null : product.defaultSpeed,
          false,
        ),
      )
      yield effects.put.resolve(
        updateFilter('period', product.defaultPeriod, false),
      )
      yield effects.put.resolve(
        updateFilter('contract', product.defaultContract, false),
      )

      break
    }

    case 'speed':
      if (!action.payload.cascade) {
        return
      }

      yield effects.put.resolve(
        updateFilter(
          'period',
          pick(product, filterData, 'periods', 'defaultPeriod'),
          false,
        ),
      )
      yield effects.put.resolve(
        updateFilter(
          'contract',
          pick(product, filterData, 'contracts', 'defaultContract'),
          false,
        ),
      )
      break

    case 'contract':
      if (!action.payload.cascade) {
        return
      }

      yield effects.put.resolve(
        updateFilter(
          'period',
          pick(product, filterData, 'periods', 'defaultPeriod'),
          false,
        ),
      )
      break

    // skip-default
  }
}

function pick(product, filterData, plural, single) {
  if (filterData.get(plural).has(product.get(single))) {
    return product.get(single)
  }

  return filterData.get(plural).first()
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/updateFilter.js